/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Billing_Partner_ManagedInputs */



/**
* | output |
* | --- |
* | "Billed by your partner. Usage is invoiced outside oneAI." |
*
* @param {Dashboard_Billing_Partner_ManagedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_billing_partner_managed = /** @type {((inputs?: Dashboard_Billing_Partner_ManagedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Billing_Partner_ManagedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wird von Ihrem Partner abgerechnet. Die Nutzung wird außerhalb von oneAI berechnet.")
	return /** @type {LocalizedString} */ ("Billed by your partner. Usage is invoiced outside oneAI.")
});